var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Terms and Conditions")]),_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Mollitia alias eum, fuga maiores vero, saepe consectetur officiis incidunt corrupti inventore reprehenderit est sapiente quo animi! Delectus minima eius libero odio.")])])
}]

export { render, staticRenderFns }